var t=()=>{try{if(window.parent.location.href)return window.location!==window.parent.location}catch(t){return!1}};export{t as default};
